import { useConcurso } from '../../../../../providers/ConcursoProvider';
import CargaCoordConcur from '../../CargaCoordConcur';

const TramitarDirector = () => {
  const concurso = useConcurso();
  const etapa = concurso.etapaLlamadoConcurso.idEtapaLlamadoConcurso;

  switch (etapa) {
    case 2:
      return <CargaCoordConcur concurso={concurso} />;
    /*
    case 3:
      <DesignacionVeedores concurso={concurso} />;
    case 4:
      return <CargaDictamen concurso={concurso} />;
    case 5:
      return <PrimerActa />;
    case 6:
      return <CargaActoAdministrativo />;
    case 7:
      return <Publicar />;
     
    case 8:
      return <ConcursoPublicado />;
      
    case 9:
      return (
        <Container>
          <AccionesConcurso />
        </Container>
      );
      */
    case 11:
      return <h1>Falta definir pantalla para estado "VALIDACION DOCUMENTAL"</h1>;
    default:
      return <div>No se reconoce el estado del concurso activo</div>;
  }
};
export default TramitarDirector;
